import React, { useState } from "react";
import { toast } from "sonner";
import { Printer, Loader2, X, CheckSquare } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

// Builds the A4 photo report (landscape 2/page stacked, portrait 4/page 2x2) and opens it for printing.
export async function openPhotoReport(ids, captions = false, cover = false) {
  const win = window.open("", "_blank");
  const r = await api.post("/media/photo-report", { file_ids: ids, captions, cover }, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  if (win) { win.location.href = url; return; }
  const a = document.createElement("a");
  a.href = url; a.download = `Fotobericht_${new Date().toISOString().slice(0, 10)}.pdf`; a.click();
}

export default function PhotoReportBar({ selected, total, onSelectAll, onCancel }) {
  const [busy, setBusy] = useState(false);
  const [captions, setCaptions] = useState(() => localStorage.getItem("photoReportCaptions") === "1");
  const toggleCaptions = (v) => { setCaptions(v); localStorage.setItem("photoReportCaptions", v ? "1" : "0"); };
  const [cover, setCover] = useState(() => localStorage.getItem("photoReportCover") === "1");
  const toggleCover = (v) => { setCover(v); localStorage.setItem("photoReportCover", v ? "1" : "0"); };
  const run = async () => {
    if (!navigator.onLine) return toast.error("Der Fotobericht braucht eine Internetverbindung");
    setBusy(true);
    try { await openPhotoReport(selected, captions, cover); }
    catch (_) { toast.error("Fotobericht konnte nicht erstellt werden"); }
    setBusy(false);
  };
  return (
    <div className="sticky top-16 z-30 mb-3 flex flex-wrap items-center gap-2 rounded-xl border border-primary/30 bg-white/95 backdrop-blur px-3 py-2 shadow-sm" data-testid="photo-report-bar">
      <span className="text-sm font-semibold" data-testid="photo-report-count">{selected.length} ausgewählt</span>
      <span className="hidden sm:inline text-xs text-slate-500">Querformat: 2 je Seite · Hochformat: 4 je Seite</span>
      <div className="flex-1" />
      <label className="flex items-center gap-1.5 text-sm cursor-pointer select-none px-1" data-testid="photo-report-captions-label">
        <input type="checkbox" className="h-4 w-4 accent-[hsl(var(--primary))]" checked={captions}
          onChange={(e) => toggleCaptions(e.target.checked)} data-testid="photo-report-captions-toggle" />
        Mit Beschriftung
      </label>
      <label className="flex items-center gap-1.5 text-sm cursor-pointer select-none px-1" data-testid="photo-report-cover-label">
        <input type="checkbox" className="h-4 w-4 accent-[hsl(var(--primary))]" checked={cover}
          onChange={(e) => toggleCover(e.target.checked)} data-testid="photo-report-cover-toggle" />
        Mit Deckblatt
      </label>
      <Button size="sm" variant="ghost" onClick={onSelectAll} data-testid="photo-report-select-all">
        <CheckSquare className="h-4 w-4 mr-1" />{selected.length === total ? "Keine" : "Alle"}
      </Button>
      <Button size="sm" variant="ghost" onClick={onCancel} data-testid="photo-report-cancel"><X className="h-4 w-4 mr-1" />Abbrechen</Button>
      <Button size="sm" onClick={run} disabled={!selected.length || busy} data-testid="photo-report-create">
        {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Printer className="h-4 w-4 mr-1" />}Bericht drucken
      </Button>
    </div>
  );
}
